import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';
import { AsyncFunctionsService } from '../../shared/services/async-functions.service';
import {
  ACCOUNT_SECTION_BREAKER, ACCOUNTS_NAV, ACCOUNTS_NAV_CHILDREN,
  PAYMENTS_SECTION_BREAKER, PAYMENTS_NAV, PAYMENTS_NAV_CHILDREN,
  ADMIN_SECTION_BREAKER,
  CASH_REGISTER_NAV,
  CASH_REGISTER_NAV_CHILDREN,
  DASHBOARD_NAV,
  FULFILMENT_NAV,
  FULFILMENT_NAV_CHILDREN, INVENTORY_NAV, INVENTORY_NAV_CHILDREN, PARTNER_SETTINGS_NAV, PARTNER_SETTINGS_NAV_CHILDREN,
  // MFG_NAV,
  // MFG_NAV_CHILDREN,
  PRODUCTS_NAV,
  PRODUCTS_NAV_CHILDREN,
  PURCHASES_NAV,
  PURCHASES_NAV_CHILDREN,
  REPORTS_NAV,
  REPORTS_NAV_CHILDREN,
  SALES_NAV,
  SALES_NAV_CHILDREN,
  SETTINGS_NAV,
  SETTINGS_NAV_CHILDREN,
  STOCK_ADJUSTMENT_NAV,
  STOCK_ADJUSTMENT_NAV_CHILDREN,
  STOCK_AUDIT_NAV,
  STOCK_AUDIT_NAV_CHILDREN,
  STOCK_TRANSFER_NAV,
  STOCK_TRANSFER_NAV_CHILDREN, STOCK_WITHDRAWER_NAV, STOCK_WITHDRAWER_NAV_CHILDREN, UPLOADS_NAV, UPLOADS_NAV_CHILDREN
} from '../../shared/constants/sideNavs';
import { FunctionsService } from '../../shared/services/functions.service';
import * as moment from 'moment';
@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent implements OnInit {
  public sidebarMinimized = false;
  public navItems;
  hotelName;
  employeeName;
  userAccessRole;
  employeeId;
  currentYear;
  hotelId;

  constructor(
    private authService: AuthService,
    private asyncFunctions: AsyncFunctionsService,
    private functions: FunctionsService
  ) {}

  async ngOnInit(): Promise<void> {
    this.getDisplayDetails();
    await this.performUserAuthorization();
    this.asyncFunctions.getHotelEmployees();
    this.currentYear = moment().format('YYYY-MM-DD HH:mm:00');
  }

  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }

  logOut() {
    const momentDateTime = moment().format('YYYY-MM-DD HH:mm:00');
    const details = {
      employeeId: this.employeeId,
      logoutDateTime: momentDateTime
    };
    this.authService
      .insertLogoutDetails('employees/insertLogout', details)
      .subscribe(
        (res) => {
          this.authService.logOut();
        },
        (err) => {
          console.log(err);
        }
      );
    // this.authService.logOut();
  }

  async composeNavItems() {
    const { permissions } = await this.asyncFunctions.getAccessRoleData();
    const userNavItems = [];
    console.log('permissions', permissions);
    for (const permission of permissions) {
      const permissionOptions = permission.options.map((e) => e.optionValue);
      switch (permission.permissionValue) {
        case 'dashboard':
          userNavItems.push(DASHBOARD_NAV);
          break;
        case 'products':
          const productNav = { ...PRODUCTS_NAV };
          productNav.children = PRODUCTS_NAV_CHILDREN.filter((e) => {
            if (e.id === 'inactive_serial_store' && String(this.hotelId) !== '1') {
              return false;
            }
            return permissionOptions.includes(e.id);
          });
          userNavItems.push(productNav);
          break;
        case 'menu':
        case 'unit':
        case 'category':
          const [currentProductsNav] = userNavItems.filter(
            (e) => e.id === 'products'
          );
          const [itemNav] = PRODUCTS_NAV_CHILDREN.filter((e) =>
            permissionOptions.includes(e.id)
          );
          if (currentProductsNav) {
            currentProductsNav.children.push(itemNav);
          } else {
            const productNav2 = { ...PRODUCTS_NAV };
            productNav2.children = [itemNav];
            userNavItems.push(productNav2);
          }
          break;
        case 'cash_register':
          const cashRegisterNav = { ...CASH_REGISTER_NAV };
          cashRegisterNav.children = CASH_REGISTER_NAV_CHILDREN.filter((e) =>
            permissionOptions.includes(e.id)
          );
          userNavItems.push(cashRegisterNav);
          break;
        case 'sales':
          const salesNav = { ...SALES_NAV };
          salesNav.children = SALES_NAV_CHILDREN.filter((e) =>
            permissionOptions.includes(e.id)
          );
          userNavItems.push(salesNav);
          break;
        case 'purchases':
          const purchasesNav = { ...PURCHASES_NAV };
          purchasesNav.children = PURCHASES_NAV_CHILDREN.filter((e) =>
            permissionOptions.includes(e.id)
          );
          userNavItems.push(purchasesNav);
          break;
        case 'uploads':
          const uploadNav = { ...UPLOADS_NAV };
          uploadNav.children = UPLOADS_NAV_CHILDREN.filter((e) =>
            permissionOptions.includes(e.id)
          );
          userNavItems.push(uploadNav);
          break;
        case 'inventory':
          const inventoryNav = { ...INVENTORY_NAV };
          inventoryNav.children = INVENTORY_NAV_CHILDREN.filter((e) =>
            permissionOptions.includes(e.id)
          );
          userNavItems.push(inventoryNav);
          break;
        case 'stock_transfer':
          const stockTransferNav = { ...STOCK_TRANSFER_NAV };
          stockTransferNav.children = STOCK_TRANSFER_NAV_CHILDREN.filter((e) =>
            permissionOptions.includes(e.id)
          );
          userNavItems.push(stockTransferNav);
          break;
        case 'partner_settings':
          const partnerSettingNav = { ...PARTNER_SETTINGS_NAV };
          partnerSettingNav.children = PARTNER_SETTINGS_NAV_CHILDREN.filter((e) =>
            permissionOptions.includes(e.id)
          );
          userNavItems.push(partnerSettingNav);
          break;
        case 'stock_adjustment':
          const stockAdjustmentNav = { ...STOCK_ADJUSTMENT_NAV };
          stockAdjustmentNav.children = STOCK_ADJUSTMENT_NAV_CHILDREN.filter(
            (e) => permissionOptions.includes(e.id)
          );
          userNavItems.push(stockAdjustmentNav);
          break;
        case 'stock_audit':
          const stockAuditNav = { ...STOCK_AUDIT_NAV };
          stockAuditNav.children = STOCK_AUDIT_NAV_CHILDREN.filter((e) =>
            permissionOptions.includes(e.id)
          );
          userNavItems.push(stockAuditNav);
          break;
        case 'stock_withdrawer':
          const stockWithdrawerNav = { ...STOCK_WITHDRAWER_NAV };
          stockWithdrawerNav.children = STOCK_WITHDRAWER_NAV_CHILDREN.filter((e) =>
            permissionOptions.includes(e.id)
          );
          userNavItems.push(stockWithdrawerNav);
          break;
        // case 'mfg':
        //   const mfgNav = { ...MFG_NAV };
        //   mfgNav.children = MFG_NAV_CHILDREN.filter((e) =>
        //     permissionOptions.includes(e.id)
        //   );
        //   userNavItems.push(mfgNav);
        //   break;
        case 'fulfilments':
          const fulfilNav = { ...FULFILMENT_NAV };
          fulfilNav.children = FULFILMENT_NAV_CHILDREN.filter((e) =>
            permissionOptions.includes(e.id)
          );
          userNavItems.push(fulfilNav);
          break;
        case 'accounting':
          // const accountNavBreaker = {...ACCOUNT_SECTION_BREAKER};
          const accountNav = { ...ACCOUNTS_NAV };
          accountNav.children = ACCOUNTS_NAV_CHILDREN.filter((e) =>
            permissionOptions.includes(e.id)
          );
          userNavItems.push(ACCOUNT_SECTION_BREAKER);
          userNavItems.push(accountNav);
          break;
        case 'payments':
          const paymentsNav = { ...PAYMENTS_NAV };
          paymentsNav.children = PAYMENTS_NAV_CHILDREN.filter((e) =>
            permissionOptions.includes(e.id)
          );
          userNavItems.push(PAYMENTS_SECTION_BREAKER);
          userNavItems.push(paymentsNav);
          break;
        case 'reports':
          const reportsNav = { ...REPORTS_NAV };

          const isEbanking = this.hotelName?.toLowerCase().includes('ebanking');

          reportsNav.children = REPORTS_NAV_CHILDREN.filter((e) => {
            if (isEbanking && e.id === 'partners_activities_reports') {
              return false;
            }
            return permissionOptions.includes(e.id);
          });

          userNavItems.push(reportsNav);
          break;
        case 'settings':
          const settingsNav = { ...SETTINGS_NAV };
          settingsNav.children = SETTINGS_NAV_CHILDREN.filter((e) =>
            permissionOptions.includes(e.id)
          );
          userNavItems.push(settingsNav);
          // userNavItems.push(adminNav);
          break;
        // case 'roles':
        //   const roleNav = { ...ROLES };
        //   settingsNav.children = SETTINGS_NAV_CHILDREN.filter((e) =>
        //     permissionOptions.includes(e.id)
        //   );
        //   userNavItems.push(settingsNav);
        //   // userNavItems.push(adminNav);
        //   break;
        case 'contacts':
          const [adminSection] = userNavItems.filter(
            (e) => e.id === 'settings'
          );
          if (adminSection) {
            const [navItem] = SETTINGS_NAV_CHILDREN.filter(
              (e) => e.id === permission.permissionValue
            );
            adminSection.children.push(navItem);
          }
          break;
      }
      if (this.hotelId !== '1') {
        const order = [
          'dashboard',
          'partner_settings',
          'stock_transfer',
          'inventory',
          'purchases',
          'products',
          'reports',
        ];

        userNavItems.sort((a, b) => {
          const aIndex = order.indexOf(a.id);
          const bIndex = order.indexOf(b.id);
          if (aIndex === -1 && bIndex === -1) { return 0; }
          if (aIndex === -1) { return 1; }
          if (bIndex === -1) { return -1; }
          return aIndex - bIndex;
        });
      }
    }

    // Always expose "Lookup PUK Lists" for users that already have the
    // Inventory or Uploads menu, regardless of the lookup permission option.
    const lookupEntry = INVENTORY_NAV_CHILDREN.find(
      (e) => e.id === 'lookup_puk_lists'
    );
    if (lookupEntry) {
      const [inventoryNav] = userNavItems.filter((e) => e.id === 'inventory');
      const [uploadsNav] = userNavItems.filter((e) => e.id === 'uploads');
      const hasLookup = (nav) =>
        nav && nav.children.some((c) => c.id === 'lookup_puk_lists');

      if (inventoryNav && !hasLookup(inventoryNav)) {
        inventoryNav.children.push({ ...lookupEntry });
      } else if (uploadsNav && !hasLookup(uploadsNav)) {
        uploadsNav.children.push({ ...lookupEntry });
      }
    }

    return userNavItems;
  }

  async performUserAuthorization() {
    this.navItems = await this.composeNavItems();
  }

  getDisplayDetails() {
    const currentHotel = JSON.parse(localStorage.getItem('current:hotel'));
    this.hotelName = currentHotel?.hotelName;
    this.hotelId = currentHotel?.hotelId;

    const { employeeName, employeeId } = JSON.parse(
      localStorage.getItem('employee')
    );
    this.employeeName = employeeName;
    this.employeeId = employeeId;
  }
}
